<template>
  <div v-if="chapters.length">
    <button ref="modalcontroller" v-on:click="showModal = true" :title="$t('change_chapter')" class="s-vam">
      <span>{{ selectedTitle }}</span>&nbsp;
      <icon class="u-dimmed" name="caret-down" scale="1"></icon>
    </button>

    <modal :isOpen="showModal" v-on:closemodal="afterModalClose">
      <modal-menu :items="chapters" :selected="selected">
        <template slot-scope="chapter">
          <button v-on:click="goTo(chapter.index)">{{ chapterTitle(chapter.title, chapter.index) }}</button>
        </template>
      </modal-menu>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    chapters: {
      default: []
    },
    selected: {
      default: null
    }
  },

  data () {
    return {
      showModal: false
    }
  },

  computed: {
    selectedTitle () {
      return this.chapterTitle(
        this.selected.title,
        this.chapters.indexOf(this.selected)
      )
    }
  },

  methods: {
    goTo (index) {
      this.showModal = false
      this.$store.dispatch('gotoChapter', index)
    },

    chapterTitle (title, index) {
      // Title's value evaluated as falsy:
      // null, undefined, NaN, empty string (''), 0, false
      return title || `${this.$i18n.t('chapter')} ${index + 1}`
    },

    afterModalClose () {
      this.showModal = false
      this.$refs.modalcontroller.focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TableOfContents.vue